// components/InfoBox.tsx
import { BsInfoCircle } from 'react-icons/bs';
import React from 'react';

type InfoBoxProps = {
  title: string;
  value: string;
  badge?: string;
  tooltip?: string;
  extraContent?: React.ReactNode;
};

export const EarningInfoBox = ({
  title,
  value,
  badge,
  tooltip,
  extraContent,
}: InfoBoxProps) => {
  return (
    <div className='space-y-6 border border-gray-200 primary-shadow p-4 relative'>
      <div className='flex justify-between'>
        <p className='font-bold text-xl'>
          {title}
          {badge && (
            <span className='ml-2 px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full'>
              {badge}
            </span>
          )}
        </p>
        {tooltip && (
          <div className='group relative'>
            <BsInfoCircle color='#1133BB' size={22} className='mt-1' />
            <div className='hidden group-hover:block absolute right-0 w-64 p-2 mt-1 bg-white border border-gray-200 rounded-md shadow-md z-10'>
              <p className='text-sm'>{tooltip}</p>
            </div>
          </div>
        )}
      </div>

      <p className='text-xl font-semibold'>{value}</p>

      {extraContent}
    </div>
  );
};
